import { useState } from 'react';
import { useAuditLog, useAuditStats } from '../api/intelligence';

const ACTION_COLORS: Record<string, string> = {
  post: 'bg-green-500/20 text-green-400',
  put: 'bg-amber-500/20 text-amber-400',
  patch: 'bg-amber-500/20 text-amber-400',
  delete: 'bg-red-500/20 text-red-400',
  get: 'bg-blue-500/20 text-blue-400',
};

export default function AuditPage() {
  const [userFilter, setUserFilter] = useState('');
  const [actionFilter, setActionFilter] = useState('');
  const { data, isLoading } = useAuditLog({
    user_id: userFilter || undefined,
    action: actionFilter || undefined,
  });
  const { data: stats } = useAuditStats();

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-gray-100">Audit Trail</h1>
        <p className="text-sm text-gray-500 mt-1">Historique complet des actions utilisateur</p>
      </div>

      {/* Stats */}
      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.top_users?.slice(0, 4).map((u: { user_id: string; count: number }) => (
            <div key={u.user_id} className="glass-panel p-4 text-center">
              <p className="text-lg font-bold text-cyber-cyan">{u.count}</p>
              <p className="text-xs text-gray-500 truncate">{u.user_id}</p>
            </div>
          ))}
        </div>
      )}

      {/* Filters */}
      <div className="flex gap-3">
        <input
          value={userFilter}
          onChange={(e) => setUserFilter(e.target.value)}
          placeholder="Filtrer par utilisateur..."
          className="px-3 py-2 text-sm bg-surface-tertiary border border-border-subtle rounded-lg text-gray-300 w-60"
        />
        <select
          value={actionFilter}
          onChange={(e) => setActionFilter(e.target.value)}
          className="px-3 py-2 text-sm bg-surface-tertiary border border-border-subtle rounded-lg text-gray-300"
        >
          <option value="">Toutes actions</option>
          <option value="post">POST</option>
          <option value="put">PUT</option>
          <option value="delete">DELETE</option>
          <option value="get">GET</option>
        </select>
      </div>

      {isLoading && (
        <div className="flex items-center justify-center py-16">
          <div className="w-8 h-8 border-2 border-cyber-cyan/30 border-t-cyber-cyan rounded-full animate-spin" />
        </div>
      )}

      {data && data.items.length > 0 && (
        <div className="glass-panel overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-border-subtle">
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Date</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Utilisateur</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Action</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Ressource</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">IP</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((entry) => (
                <tr key={entry.id} className="border-b border-border-subtle/50 hover:bg-surface-tertiary/30 transition-colors">
                  <td className="px-4 py-3 text-xs text-gray-400">
                    {new Date(entry.created_at).toLocaleString('fr-FR')}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-300">{entry.user_id}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 text-xs rounded-full uppercase ${ACTION_COLORS[entry.action] || 'bg-gray-500/20 text-gray-400'}`}>
                      {entry.action}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-400 font-mono truncate max-w-[300px]">
                    {entry.resource_type}
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-500 font-mono">{entry.ip_address || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!isLoading && data && data.items.length === 0 && (
        <p className="text-center text-gray-500 py-12">Aucune entree dans le journal d'audit</p>
      )}
    </div>
  );
}
